import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, Button, Col, DatePicker, Descriptions, Row, Table } from 'antd';

import SectionTitle from '../../../../components/UI/Panels/SectionTitle/SectionTitle';

import ReportsService from '../../../../services/reports';
import { errorNotification } from '../../../../components/UI/Notifications/Notifications';
import { API } from 'aws-amplify';
import moment from 'moment';
import { disableHotelSelector, enableHotelSelector } from '../../../../store/actions';


const MaidActivityReport = () => {
    const dispatch = useDispatch();
    const queryString = useLocation();

    const cid = useSelector(state => state.base.cid ?? '');
    const hid = useSelector(state => state.ui.selectedHotel ?? 0);

    const [loading, setLoading] = useState(false);
    const [canGenerate, setCanGenerate] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [cleans, setCleans] = useState([]);
    const [totalCleans, setTotalCleans] = useState(0);

    const maidColumns = [
        {title: 'Nombre', dataIndex: 'Name', key: 'Name', defaultSortOrder: 'ascend', sorter: {compare: (a,b) => parseInt(a.Name) - parseInt(b.Name)}},
        {title: 'Limpiezas', dataIndex: 'Total', key: 'Total', defaultSortOrder: 'ascend', sorter: {compare: (a,b) => parseInt(a.Total) - parseInt(b.Total)}}
    ];

    useEffect(async () => {
        dispatch(enableHotelSelector());
    
        return () => {
            dispatch(disableHotelSelector());
        };
    }, []);

    useEffect(() => {
        if (hid != null &&
            startDate != null && endDate != null &&
            startDate < endDate) {
                setCanGenerate(true);
            } else {
                setCanGenerate(false);
            }

    }, [hid, startDate, endDate]);

    const disabledDate = (current) => {
        if (!current) return false;
        
        // Start of the previous month
        const startRange = moment().subtract(1, 'months').startOf('month');
        // End of the current month
        const endRange = moment().endOf('month');

        // Disable if before startRange OR after endRange
        return current.isBefore(startRange, 'day') || current.isAfter(endRange, 'day');
    };

    const generateReport = () => {
        API.get("benackoAPI", "/v2/actions?hotelId=" + hid +
                "&type=3" +
                "&startTimestamp=" + startDate +
                "&endTimestamp=" + endDate)
                .then(res => {
                    const actions = res.Items ?? [];
                    const cleans = actions.filter(a => a.itemType === 'cleanAction');

                    const totals = new Map();
                    const items = [];
                    cleans.forEach(clean => {
                        if (totals.has(clean.maid)) {
                            let curr = totals.get(clean.maid);
                            totals.set(clean.maid, curr + 1);
                        } else {
                            totals.set(clean.maid, 1);
                        }
                    });

                    const result = Array.from(totals, ([name, total]) => ({ Name: name, Total: total }));
                    setCleans(result);
                    setTotalCleans(cleans.length);
                })
                .catch(err => console.error('Error loading cleans', err))
                .finally(() => setLoading(false));
    };

    const processStartDate = (moments) => {
        const formattedDate = moments.format('yyyy-MM-DD');
        let start = new Date(formattedDate);
        start.setHours(0);
        start.setMinutes(0);
        start = start.getTime();
        setStartDate(start);
    };

    const processEndDate = (moments) => {
        const formattedDate = moments.format('yyyy-MM-DD');
        let end = new Date(formattedDate);
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        end = end.getTime();
        setEndDate(end);
    };

    return (
        <Row style={{display: 'flex', flexFlow: 'column', width: '100%'}}>
            <SectionTitle title={'Actividad de recamareras'} />

            <Row style={{width: '100%', marginTop: 30, marginLeft: 40}}>
                <Row style={{width: '100%', height: 110, display: 'flex', alignItems: 'center'}}>
                    <Descriptions title='Información' bordered>
                        <Descriptions.Item label='Fecha inicial'>
                            <DatePicker disabledDate={disabledDate} allowClear={false} style={{width: '100%'}} onChange={e => processStartDate(e)}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='Fecha final'>
                            <DatePicker disabledDate={disabledDate} allowClear={false} style={{width: '100%'}} onChange={e => processEndDate(e)}/>
                        </Descriptions.Item>
                        <Descriptions.Item>
                            <Button type='primary' onClick={generateReport} disabled={!canGenerate}>Generar Reporte</Button>
                        </Descriptions.Item>
                    </Descriptions>
                </Row>

                <Row style={{width: '100%', margin: 20, display: 'flex', alignItems: 'center'}}>
                    <span><b>Limpiezas del periodo:</b> {totalCleans ?? 0}</span>
                </Row>
                <Row style={{width: '100%', height: '100%', marginTop: 10}}>
                    <Table
                        style={{width: '95%'}}
                        size='small'
                        pagination={false}
                        scroll={{y: 550}}
                        columns={maidColumns}
                        dataSource={cleans}
                        rowKey='Name'
                        loading={loading}
                    />
                </Row>
            </Row>
        </Row>
    );
};

export default MaidActivityReport;